// extracted by mini-css-extract-plugin
export var phone = "_2o-0";